import { useEffect, useRef } from 'react';

interface ContextMenuProps {
  x: number;
  y: number;
  onNewFile: () => void;
  onNewFolder: () => void;
  onRename: () => void;
  onDelete: () => void;
  onClose: () => void;
}

export default function ContextMenu({
  x,
  y,
  onNewFile,
  onNewFolder,
  onRename,
  onDelete,
  onClose,
}: ContextMenuProps) {
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        onClose();
      }
    };
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEscape);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [onClose]);

  const items = [
    { label: 'New File', action: onNewFile },
    { label: 'New Folder', action: onNewFolder },
    { type: 'separator' as const },
    { label: 'Rename', action: onRename },
    { label: 'Delete', action: onDelete, danger: true },
  ];

  return (
    <div
      ref={menuRef}
      className="fixed z-50 bg-[#252526] border border-[#3c3c3c] rounded shadow-xl py-1 min-w-[160px]"
      style={{ left: x, top: y }}
    >
      {items.map((item, i) =>
        'type' in item && item.type === 'separator' ? (
          <div key={i} className="border-t border-[#3c3c3c] my-1" />
        ) : (
          <button
            key={i}
            className={`w-full text-left px-3 py-1.5 text-xs hover:bg-[#094771] transition-colors ${
              'danger' in item && item.danger
                ? 'text-red-400 hover:text-red-300'
                : 'text-gray-300'
            }`}
            onClick={() => {
              if ('action' in item) item.action();
              onClose();
            }}
          >
            {'label' in item ? item.label : ''}
          </button>
        )
      )}
    </div>
  );
}
